import React, { FunctionComponent } from 'react';
import { Typography } from '@rbx/ui';
import { OpenAPI, HttpMethods } from '../../../utils/oasTypes';
import useColoredMethodStyles from './ColoredMethod.styles';

export interface ColoredMethodProps {
  method: HttpMethods;
  marginRight?: number;
  style?: React.CSSProperties;
}

const ColoredMethod: FunctionComponent<React.PropsWithChildren<ColoredMethodProps>> = ({
  method,
  marginRight = 0,
  style = {},
}) => {
  const {
    classes: { get, put, post, del, options, head, patch, trace, root },
    cx,
  } = useColoredMethodStyles();

  let methodRoot;
  switch (method) {
    case OpenAPI.HttpMethods.GET:
      methodRoot = get;
      break;
    case OpenAPI.HttpMethods.PUT:
      methodRoot = put;
      break;
    case OpenAPI.HttpMethods.POST:
      methodRoot = post;
      break;
    case OpenAPI.HttpMethods.DELETE:
      methodRoot = del;
      break;
    case OpenAPI.HttpMethods.OPTIONS:
      methodRoot = options;
      break;
    case OpenAPI.HttpMethods.HEAD:
      methodRoot = head;
      break;
    case OpenAPI.HttpMethods.PATCH:
      methodRoot = patch;
      break;
    case OpenAPI.HttpMethods.TRACE:
      methodRoot = trace;
      break;
    default:
      methodRoot = get;
  }
  return (
    <Typography
      variant='code'
      classes={{ root: cx(root, methodRoot) }}
      marginRight={marginRight}
      style={style}>
      {method.toLocaleUpperCase()}
    </Typography>
  );
};

export default ColoredMethod;
